import { Component } from "react"

export default class extends Component {

    constructor(props, context) {
        super(props, context);

        this.getOverflowFillPercentage = this.getOverflowFillPercentage.bind(this);
        this.getOverflowPercentage = this.getOverflowPercentage.bind(this);
        this.getOverflowStatusCode = this.getOverflowStatusCode.bind(this);
        this.getOverflowStatusTitle = this.getOverflowStatusTitle.bind(this);
    }

    getOverflowStatusCode( overflowStartDate, overflowEndDate){
        if( overflowStartDate && !overflowEndDate ){
            return 1;
        }
        else if( overflowStartDate && overflowEndDate){
            return 2;
        }
        else {
            return 3
        }
    }

    getOverflowStatusTitle( overflowStartDate, overflowEndDate){
        if( this.getOverflowStatusCode(overflowStartDate, overflowEndDate) === 1 ){
            return "Overflow Occuring";
        }
        else if( this.getOverflowStatusCode(overflowStartDate, overflowEndDate) === 2){
            return "Overflow in Past 24hrs";
        }
        else {
            return "No Overflow in Past 24hrs"
        }
    }

    getOverflowPercentage(pipeDiameter, pipeVal){
        return ((pipeVal / pipeDiameter )* 100).toFixed(0);
    }

    getOverflowFillPercentage(pipeDiameter, pipeVal){

        let overflowPercentage = this.getOverflowPercentage(pipeDiameter, pipeVal);
        let circleMaskMaxHeight = 84;
        return ( circleMaskMaxHeight - (( overflowPercentage * circleMaskMaxHeight) / 100 ) );
    }

    render(){
        const { overflowStartDate,
                overflowEndDate,
                overflowPipeDiameter,
                overflowPipeLevelCurrentVal,
                overflowPast24hrRainfall } = this.props;

        return(
            <div className={"overflow-status-" + this.getOverflowStatusCode(overflowStartDate,overflowEndDate)}>

                <div className="circle-chart">
                    <div className="chart-left">
                        <svg width="100%" height="50" viewBox="0 0 84 84">
                            <defs>
                                <mask id="mask" x="0" y="0">
                                    <circle cx="42" cy="42" r="40" style={{fill: "#fff"}}/>
                                </mask>
                            </defs>
                            <circle cx="42" cy="42" r="40.5" style={{ fill: "#f1f2f3", stroke: "#b1b2b3", strokeWidth: 1}} />
                            <rect id="circle-chart-fill" x="0" y={ this.getOverflowFillPercentage( overflowPipeDiameter, overflowPipeLevelCurrentVal)} width="84" height="84" style={{ mask: "url(#mask)", transition: "all 1s", strokeWidth: 2 }} />
                        </svg>
                    </div>
                    <div className="chart-right">
                        <span className="chart-value">{ this.getOverflowPercentage( overflowPipeDiameter, overflowPipeLevelCurrentVal) }%</span>
                    </div>
                </div>
                <div className="circle-chart-title mb-2">{ this.getOverflowStatusTitle( overflowStartDate, overflowEndDate) }</div>

                <table className="site-table">
                    <tbody>
                    <tr>
                        <td>Start</td>
                        <td>{(!overflowStartDate) ? "-" : overflowStartDate}</td>
                    </tr>
                    <tr>
                        <td>End</td>
                        <td>{ ( overflowStartDate && !overflowEndDate) ? "In Progress" : (!overflowStartDate) ? "-" : overflowEndDate}</td>
                    </tr>
                    <tr>
                        <td>Past 24hr Rainfall</td>
                        <td>{overflowPast24hrRainfall}mm</td>
                    </tr>
                    </tbody>
                </table>
            </div>

        )
    }
}




// WEBPACK FOOTER //
// ./src/components/site/overflow/overflow-component.js